import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { navLinks } from '../../data/mock';
import '../../styles/landing.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <header className={`header-nav ${isScrolled ? 'scrolled' : ''}`}>
        <button
          type="button"
          className="brand-logo-link"
          onClick={() => scrollToSection('#inicio')}
          aria-label="Ir al inicio"
        >
          <img
            src="/brand/eliana-cpc-reverse.svg"
            alt="CPC Eliana Espilco"
            className="brand-logo"
          />
        </button>

        <nav className="nav-links">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => scrollToSection(link.href)}
              className="nav-link"
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="header-actions flex items-center gap-4">
          <button
            onClick={() => scrollToSection('#contacto')}
            className="btn-primary hidden lg:flex"
          >
            Consulta Gratis
          </button>
          
          <button
            className="lg:hidden bg-transparent border-none cursor-pointer text-white"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Menu"
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-[998] bg-[#0a1628] pt-28 px-8 lg:hidden">
          <nav className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <button
                key={link.href}
                onClick={() => scrollToSection(link.href)}
                className="text-left py-4 text-lg font-medium border-b border-white/10 bg-transparent cursor-pointer text-white hover:text-[#D4AF37] transition-colors"
              >
                {link.label}
              </button>
            ))}
            <button
              onClick={() => scrollToSection('#contacto')}
              className="btn-primary mt-8"
            >
              Consulta Gratis
            </button>
          </nav>
        </div>
      )}
    </>
  );
};

export default Header;
